import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent {

  
  constructor( private titleService: Title ) {

  }
  ngOnInit() {
    /*
    this.settings$.subscribe(settings => {
      this.titleService.setTitle(settings.title)
    })
    */
  }
}
